module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-57x57-bb598ead8ae99fc1f05d57b662e01eb5.png";